import React from 'react';
import OperationalCard from './OperationalCard';

const OperationalView = ({ notifications }) => {
  const validNotifications = notifications.filter(n => n.title && n.title !== 'rebelnet-config');
  
  if (validNotifications.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">🔔</div>
        <div className="empty-state-text">Nessuna notifica operativa</div>
        <div className="empty-state-hint">Le notifiche operative appariranno qui</div>
      </div>
    );
  }

  return (
    <div className="operational-list">
      {validNotifications.map(notification => (
        <OperationalCard key={notification.id} notification={notification} />
      ))}
    </div>
  );
};

export default OperationalView;
